import { InjectionToken } from '@angular/core';

// translation token
export const TRANSLATIONS: InjectionToken<{ [key: string]: { [key: string]: string } }> = new InjectionToken('translations');

// all translations
export const dictionary = {
    'es': null,
    'en': null,
    'ca': null,
    'fr': null,
    'pt': null
};

// objects language
export const languages = [
    { value: 'es', label: 'Español' },
    { value: 'en', label: 'English' },
    { value: 'ca', label: 'Català' },
    { value: 'fr', label: 'Français' },
    { value: 'pt', label: 'Português' }
]

// providers
export const TRANSLATION_PROVIDERS = [
    { provide: TRANSLATIONS, useValue: dictionary },
];